var render = function render(_c,_vm){return _c('span',{staticClass:"icon",style:({ color: _vm.props.value ? 'green' : 'red' })},[_c('i',{class:`mdi mdi-24px mdi-${_vm.props.value ? 'check' : 'close'}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }